<template>
  <div class="OAModalForm">
    <el-dialog :visible.sync="visibleCopy" width="600px" @close="onCancel" :lock-scroll="true"
      :close-on-click-modal="false" :title="title">

      <slot></slot>
      <form-component :form-data="formData" ref="formData" :label-width="labelWidth||'120px'"></form-component>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmit" :loading="saving">确定</el-button>
        <el-button @click="onCancel">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import formComponent from "@/components/formComponents/form-component.vue";
  import {
    getValue
  } from "@/common/util.js";
  export default {
    name: "OAModalForm",
    props: ["title", "visible", "formData", "labelWidth", "saving"],
    components: {
      formComponent
    },
    data() {
      return {
        visibleCopy: false
      };
    },
    methods: {
      onCancel() {
        this.$refs.formData.$children[0].resetFields();
        this.$emit("on-cancel");
      },
      onSubmit() {
        this.$refs.formData.validate(async valid => {
          if (valid) {
            let data = getValue(this.formData);
            this.$emit("on-submit", data);
          }
        });
      }
    },
    watch: {
      visible: {
        handler: function (val, oldVal) {
          this.visibleCopy = val;
        },
        deep: true,
        immediate: true
      }
    },
    mounted() {}
  };

</script>
<style lang="scss">
  .OAModalForm {
    .el-dialog__footer {
      text-align: center;
    }

    .el-dialog__body {
      padding: 10px 20px;
    }

    .addTips {
      font-size: 12px;
      padding: 5px;
      background: #fefce4;
      color: #666;
      border: 1px solid #f3d95f;
      margin-bottom: 20px;
    }

    .addTips span {
      color: #000;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/OAModalForm/OAModalForm.vue